import cn from "classnames";
import { useState, useRef } from "react";
import { usePopper } from "react-popper";
import { useClickAway } from "react-use";

import { useMediaQuery } from "@hooks/useMediaQuery";
import SearchDestinationMobile from "@modals/SearchDestinationMobile/SearchDestinationMobile";

import Suggestions from "../Suggestions/Suggestions";

import s from "./SearchField.module.scss";

const SearchField = ({
  className,
  triggerElement,
  popperContentProps,
  modalProps,
}) => {
  const { isMobile } = useMediaQuery();
  const [isPopperOpen, setIsPopperOpen] = useState(false);

  const elementRef = useRef(null);
  const popperRef = useRef(null);
  const [popperElement, setPopperElement] = useState(null);

  const popper = usePopper(elementRef.current, popperElement, {
    placement: "bottom-start",
  });

  const closePopper = () => {
    setIsPopperOpen(false);
  };

  const handleButtonClick = () => {
    setIsPopperOpen(!isPopperOpen);
  };

  const handleDaySelect = (item) => {
    popperContentProps.selectItem(item);
    closePopper();
  };

  useClickAway(popperRef, () => {
    if (isPopperOpen) {
      closePopper();
    }
  });

  return (
    <div className={cn(s.field, className)}>
      {isMobile && modalProps.isOpen && (
        <SearchDestinationMobile {...modalProps} />
      )}
      <div ref={elementRef} onClick={handleButtonClick} className={s.element}>
        {triggerElement}
      </div>
      {isPopperOpen && !isMobile && (
        <div
          ref={(node) => {
            setPopperElement(node);
            popperRef.current = node;
          }}
          style={popper.styles.popper}
          {...popper.attributes.popper}
        >
          <Suggestions {...popperContentProps} selectItem={handleDaySelect} />
        </div>
      )}
    </div>
  );
};

export default SearchField;
